import { DSTypes } from '../../../cimsPage/instances/ds'
import { Types } from '../../common'

const types = Types({
  page: DSTypes,
  create: 'f53c6073-6e72-4e48-bac1-338245bfa540',
  view: '22883fd7-63a3-489c-be52-4535140aacc2',
  edit: 'a35a4e99-fb7f-4ec5-a0da-703e14944a2c',
  removeRestore: '30587340-6fbe-4d8e-bf16-9978b30d6ff8',
})

export const CreateDesignSubmittalType = types.Create
export const ViewDesignSubmittalType = types.View
export const EditDesignSubmittalType = types.Edit
export const RemoveRestoreDesignSubmittalType = types.RemoveRestore

export type DSTypePermission =
  | typeof CreateDesignSubmittalType
  | typeof ViewDesignSubmittalType
  | typeof EditDesignSubmittalType
  | typeof RemoveRestoreDesignSubmittalType
